import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CapabilitiesProvider } from './context/CapabilitiesContext';

import Layout from './components/Layout';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Home from './pages/Home';
import DoctorSimulator from './pages/DoctorSimulator';
import Module1SessionPage from './pages/Module1SessionPage';
import PatientSimulator from './pages/PatientSimulator';
import MedicalCopilot from './pages/MedicalCopilot';
import Help from './pages/Help';

import ProtectedRoute from './components/ProtectedRoute';
import AuthRoute from './components/AuthRoute';
import ModuleAvailabilityRoute from './components/ModuleAvailabilityRoute';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <CapabilitiesProvider>
        <Router>
          <Routes>

          {/* Landing pages */}
          <Route path="/" element={<Landing />} />
          <Route path="/landing" element={<Landing />} />

          {/* Login page */}
          <Route path="/login" element={<Login />} />

          {/* Home page - requires authentication BUT NOT consent */}
          <Route
            path="/home"
            element={
              <Layout>
                <AuthRoute>
                  <Home />
                </AuthRoute>
              </Layout>
            }
          />

          {/* Help page (no protection) */}
          <Route
            path="/help"
            element={
              <Layout>
                <Help />
              </Layout>
            }
          />

          {/* Protected module routes - require auth + consent */}
          <Route
            path="/doctor"
            element={
              <Layout>
                <ProtectedRoute>
                  <ModuleAvailabilityRoute moduleKey="module_1">
                    <DoctorSimulator />
                  </ModuleAvailabilityRoute>
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/doctor/session/:sessionId"
            element={
              <Layout>
                <ProtectedRoute>
                  <ModuleAvailabilityRoute moduleKey="module_1">
                    <Module1SessionPage />
                  </ModuleAvailabilityRoute>
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/patient"
            element={
              <Layout>
                <ProtectedRoute>
                  <ModuleAvailabilityRoute moduleKey="module_2">
                    <PatientSimulator />
                  </ModuleAvailabilityRoute>
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/copilot"
            element={
              <Layout>
                <ProtectedRoute>
                  <ModuleAvailabilityRoute moduleKey="module_3">
                    <MedicalCopilot />
                  </ModuleAvailabilityRoute>
                </ProtectedRoute>
              </Layout>
            }
          />

          {/* Catch-all redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />

          </Routes>
        </Router>
      </CapabilitiesProvider>
    </AuthProvider>
  );
}

export default App;
